import { useState } from "react";
import { Alert, Box, Button, Collapse, TextField, Typography } from "@mui/material";
import { suggestCategory } from "services/categories";

export default function CategorySuggestions({ mainCategory, bookTitle = "" }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [justification, setJustification] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);
  const submit = async () => {
    setBusy(true);
    setMessage(null);
    try {
      await suggestCategory({ mainCategory, name, justification, bookTitle });
      setMessage({
        severity: "success",
        text: "Sugestão enviada para análise. Enquanto isso, selecione uma categoria existente para publicar.",
      });
      setName("");
      setJustification("");
    } catch (error) {
      setMessage({ severity: "error", text: error.message });
    } finally {
      setBusy(false);
    }
  };
  return (
    <Box mt={3}>
      <Button onClick={() => setOpen(!open)} aria-expanded={open}>
        Não encontrou uma categoria? Sugira uma
      </Button>
      <Collapse in={open}>
        <Box
          p={2}
          mt={1}
          sx={{
            border: "1px solid #c8e6cf",
            borderRadius: 2,
            "& .MuiInputLabel-root": { lineHeight: 1.5 },
            "& .MuiInputBase-input": { lineHeight: 1.5, height: "auto" },
          }}
        >
          <Typography variant="body2" mb={2}>
            Sua sugestão em {mainCategory} será avaliada pela equipe. Ela ficará disponível após a
            aprovação.
          </Typography>
          <TextField
            label="Nome da categoria sugerida"
            InputLabelProps={{ shrink: true }}
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            inputProps={{ maxLength: 120 }}
            disabled={busy}
          />
          <TextField
            label="Por que essa categoria é importante? (opcional)"
            InputLabelProps={{ shrink: true }}
            value={justification}
            onChange={(e) => setJustification(e.target.value)}
            fullWidth
            multiline
            minRows={2}
            inputProps={{ maxLength: 1000 }}
            disabled={busy}
            sx={{ mt: 2 }}
          />
          <Button
            variant="contained"
            color="info"
            onClick={submit}
            disabled={busy || name.trim().length < 3}
            sx={{ mt: 2 }}
          >
            {busy ? "Enviando..." : "Enviar sugestão"}
          </Button>
        </Box>
      </Collapse>
      {message && (
        <Alert severity={message.severity} sx={{ mt: 2 }} onClose={() => setMessage(null)}>
          {message.text}
        </Alert>
      )}
    </Box>
  );
}
